














import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { UserInformations } from '@/services/connecteur'
import serviceModule from '@/store/modules/ServiceModule'
import userModule from '@/store/modules/UserModule'

@Component({
  components: {}
})
export default class KAMSelect extends Mixins(BaseVue) {
  @Prop({ default: 0 })
  public id!: number

  @Prop({ default: 0, required: true })
  public salesOrgId!: number

  @Prop({ default: false })
  public isCreation!: boolean

  @Prop({ default: false })
  public disabled!: boolean

  public KAMList: UserInformations[] = new Array<UserInformations>()

  public get kamError (): string {
    if (this.id) {
      const kams = this.KAMList.filter(x => x.id === this.id)

      if (!kams.length) {
        this.updateError(true)
        return this.$t('promotion.kamNotValid').toString()
      } else if (kams[0] && kams[0].desactivated) {
        this.updateError(true)
        return this.$t('promotion.kamNotActivated').toString()
      }
    }
    this.updateError(false)
    return ''
  }

  public updateId (newValue: number) {
    this.$emit('update:id', newValue)
  }

  public updateError (newValue: boolean) {
    this.$emit('update:error', newValue)
  }

  @Watch('salesOrgId', { immediate: true })
  public async updateKAMList () {
      try {
        if (this.salesOrgId) {
          this.KAMList = await serviceModule.userApi.getAllKAMs(this.salesOrgId)
        }

        if (this.isCreation && userModule.userIsKAM) {
          this.updateId(userModule.id as number)
        }
      } catch (error) {
        this.displayError(error)
      }
    }
  }
